//@flow

import React from "react"
import { FormattedMessage } from "react-intl"
import { Cubic, TweenMax } from "gsap"

import SVGLoader from "../../../UI/SVGLoader"
import {
  ContentContainer,
  Titles,
  TitleText,
  TitleDescription,
  Foreground,
  Background
} from "./UI"

import fuelForeground from "./fuelForeground.svg"
import fuelBackground from "./fuelBackground.svg"

type Props = {}

class FuelView extends React.Component<Props> {
  introText: HTMLElement[]
  background: ?HTMLElement
  foreground: ?HTMLElement
  container: ?HTMLElement

  constructor(props: Props) {
    super(props)
    this.introText = []
    this.container = null
    this.background = null
    this.foreground = null
  }

  componentDidMount() {
    this.showIntroText()
    this.showScene()
  }

  showIntroText = () => {
    const intro = this.introText.filter(el => el !== null)
    TweenMax.set(intro, { y: "40", opacity: 0 })
    TweenMax.staggerTo(
      intro,
      0.5,
      { y: "0", opacity: 1, ease: Cubic.easeOut, delay: 0.5 },
      0.2
    )
  }

  showScene = () => {
    TweenMax.set(this.background, { opacity: 0, x: -100 })
    TweenMax.set(this.foreground, { opacity: 0, x: -250 })
    TweenMax.staggerTo(
      [this.foreground, this.background],
      1,
      {
        opacity: 1,
        ease: Cubic.easeOut,
        delay: 1
      },
      0.1
    )
    TweenMax.to(this.background, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
    TweenMax.to(this.foreground, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
  }

  render() {
    return (
      <ContentContainer innerRef={el => (this.container = el)}>
        <Titles>
          <TitleText innerRef={el => this.introText.push(el)}>
            <FormattedMessage id="kiosk.commit.fuel.title" />
          </TitleText>
          <TitleDescription innerRef={el => this.introText.push(el)}>
            <FormattedMessage id="kiosk.commit.fuel.intro" />
          </TitleDescription>
        </Titles>
        <Foreground innerRef={el => (this.foreground = el)}>
          <SVGLoader path={fuelForeground} width="100%" height="100%" />
        </Foreground>
        <Background innerRef={el => (this.background = el)}>
          <SVGLoader path={fuelBackground} width="100%" height="100%" />
        </Background>
      </ContentContainer>
    )
  }
}

export default FuelView



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Fuel/index.js